import React from 'react';
import './Contact.css';

function Contact({ language }) {
  return (
    <section id="contact">
      <div className="container">
        <div className="section-title-center">
          <h2>Contact Me</h2>
          <p>Ready to start your real estate journey? Get in touch today.</p>
        </div>

        <div className="contact-container">
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>I'm here to answer any questions and help you with your real estate needs.</p>

            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-phone"></i>
              </div>
              <div>
                <h4>Phone</h4>
                <p>+1 (780) 263-6320</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div>
                <h4>Email</h4>
                <p>maggiewang@vitahomes.ca</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <h4>Office</h4>
                <p>11155 65 St NW<br />Edmonton, AB T5W 4K2<br />Canada</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <form action="https://formspree.io/f/meeyjkeg" method="POST">
              <div>
                <label>Name</label>
                <input type="text" name="name" required />
              </div>
              <div>
                <label>Email Address</label>
                <input type="email" name="email" required />
              </div>
              <div>
                <label>Phone Number</label>
                <input type="tel" name="number" />
              </div>
              <div>
                <label>Inquiry Message</label>
                <textarea name="message" required></textarea>
              </div>
              <button type="submit" className="btn">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
